export default {
  // --- warehouse-meta.tsx ---
  Name: "Nom",
  Location: "Emplacement",
  Business: "Entreprise",
  "Created At": "Créé le",
  Actions: "Actions",

  // --- warehouse-form.tsx ---
  "Location ID": "ID de l'emplacement",
  "Business ID": "ID de l'entreprise",
  Description: "Description",

  // --- select-warehouse.tsx ---
  Warehouse: "Entrepôt",
  "Add a warehouse": "Ajouter un entrepôt",
  Warehouses: "Entrepôts",
  "Search warehouse by name, description, location, or business":
    "Rechercher un entrepôt par nom, description, emplacement ou entreprise",
  "Edit Selection": "Modifier la sélection",
  "No warehouses found": "Aucun entrepôt trouvé",

  // --- create-warehouse-modal.tsx ---
  "Create a new warehouse": "Créer un nouvel entrepôt",

  // --- edit-warehouse-modal.tsx ---
  "Edit Warehouse": "Modifier l'entrepôt",

  // --- view-warehouse-modal.tsx & view-warehouse-block.tsx ---
  "General Information": "Informations générales",
  "Updated At": "Mis à jour le",

  // --- delete-warehouse-modal.tsx ---
  "Do you really want to delete this Warehouse?":
    "Voulez-vous vraiment supprimer cet entrepôt ?",
  "Warning: This action is irreversible and may lead to cascade deletions.":
    "Avertissement : Cette action est irréversible et peut entraîner des suppressions en cascade.",
  Cancel: "Annuler",
  "Confirm Deletion": "Confirmer la suppression",

  // --- warehouse-list-block.tsx ---
  "Add warehouse": "Ajouter un entrepôt",

  // --- General ---
  Submit: "Soumettre",
};
